export default __webpack_public_path__ + "static/media/person-2.e2316ed9.png";